<template>
  <div class="warehousingPage">
    <div class="banner">
      <img src="../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon">
        <i class="iconfont icon-shangpinsku"></i>
      </div>
      <div class="breadcrumb_item">SKU管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">入库管理</div>
    </div>

    <div class="main_content">
      <div class="goods_desciption">
        <p class="txt1 fontSize-blueColor-md">商品ID：{{ detail.id }}</p>
        <p class="txt2 fontSize-blueColor-md">商品名称：{{ detail.commodityname }}</p>
        <!-- <p class="txt3">{{ detail.commodityname }}</p> -->
        <p class="txt3">{{ detail.commodityname_e }}</p>
        <p class="txt3">{{ detail.commodityname_y }}</p>
        <p class="txt3">{{ detail.commodityname_m }}</p>
        <p class="txt3">{{ detail.commodityname_t }}</p>
        <p class="txt1 fontSize-blueColor-md">SKU采购编码：{{ detail.sku }}</p>
        <p class="fontSize-blueColor-md">ISBN编码： {{ detail.ISBN }}</p>
      </div>
      <div class="btn_group flex-colc">
        <!-- <div class="info-button btn1" @click="handleGo(1)">采购入库</div> -->
        <div class="info-button btn1" @click="handleGo(2)">生产入库</div>
        <div class="info-button btn1" @click="handleGo(3)">清点入库</div>
        <div class="info-button" @click="handleGo(4)">退货入库</div>
      </div>
    </div>

    <!-- <div class="default-button return" @click="handleReturn">←返回</div> -->
    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i>返回
    </div>
  </div>
</template>

<script>
import { getMenuAuthTwo, queryShop } from "../../api/api";
import { mapState } from "vuex";
export default {
  name: "wManageSettingList",
  data() {
    return {
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      detail: "",
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { keyword } = this.$route.params;
    this.keyword = keyword;
    this.getShopDetail(keyword);

    this.roleId = this.$store.state.USERINFO.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.getMenuAuthTwo();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    // 获取商品详情
    getShopDetail(keyword) {
      queryShop({ keyword, openid: this.OPENID }).then((res) => {
        this.detail = res;
        // toast.clear()
      });
    },
    handleGo(type) {
     if(type == 4) {
        this.$toast("即将开放");
        return
      }
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$toast("暂无权限");
        return;
      }
      this.$router.push(
        `/warehousIndex/wManageSettingItem/${this.detail.id}/${type}`
      );
    },
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.warehousingPage {
  padding-bottom: 120px;
  .breadcrumb {
    padding-bottom: 70px;
  }
  .main_content {
    padding: 0 100px;
    .txt1 {
      margin-bottom: 25px;
    }
    .txt2 {
      margin-bottom: 10px;
    }
    .txt3 {
      font-size: 28px !important;
      margin-bottom: 45px;
      color: #404d6c;
    }
  }
  .btn_group {
    margin-top: 89px;
    .btn1 {
      margin-bottom: 57px;
    }
  }
}
</style>